import { Box, styled } from '@mui/material';
import { createContext, useContext, useEffect, useState } from 'react';

const Wrapper = styled(Box)(({ theme, paddingEnabled, isPlayground }) => ({
  background: theme.palette.mode === 'dark' ? '#1A1B1F' : '#4487B0',
  paddingTop: theme.spacing(0),
  // [theme.breakpoints.down('md')]: {
  //   padding: (paddingEnabled && isPlayground) ? theme.spacing(2, 0, 63) : theme.spacing(2,0,0,0),
  // },
}));

const PageTitleContext = createContext();

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState({ text: '', hideOnMobile: false });
  const [paddingEnabled, setPaddingEnabled] = useState(false);
  const [isPlayground, setIsPlayground] = useState(false);
  const [exampleListCount, setExampleListCount] = useState(0);

  return (
    <PageTitleContext.Provider
      value={{
        pageTitle,
        setPageTitle,
        paddingEnabled,
        setPaddingEnabled,
        isPlayground,
        setIsPlayground,
        exampleListCount,
        setExampleListCount,
      }}
    >
      <Wrapper paddingEnabled={!paddingEnabled} isPlayground={isPlayground}>
        {children}
      </Wrapper>
    </PageTitleContext.Provider>
  );
};

export const usePageTitle = (title) => {
  const context = useContext(PageTitleContext);

  if (!context) {
    throw new Error('usePageTitle must be used within PageTitleProvider');
  }

  useEffect(() => {
    if (title) {
      // Support both string and object format for backward compatibility
      if (typeof title === 'string') {
        context.setPageTitle({ text: title, hideOnMobile: false });
      } else {
        context.setPageTitle({
          text: title.text,
          hideOnMobile: title.hideOnMobile || false,
        });
      }
    }

    // Cleanup: reset title when component unmounts
    return () => {
      context.setPageTitle({ text: '', hideOnMobile: false });
    };
  }, [title]);

  return context;
};

export const usePageTitleContext = () => {
  const context = useContext(PageTitleContext);

  if (!context) {
    throw new Error(
      'usePageTitleContext must be used within PageTitleProvider'
    );
  }

  return context;
};
